import { InjectionToken } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface QuartinaConfig {
  product_line: string;
  product: string;
  area: string;
  module: string;
}

export interface TsDeskConfig {
  accountId: string;
  standalone: QuartinaConfig;
  tsStudio: QuartinaConfig;
  tsDeskApi: string;
}

export const tsDeskConfig: TsDeskConfig = {
  accountId: environment.tsDesk.accountId,
  standalone: environment.tsDesk.standalone,
  tsStudio: environment.tsDesk.tsStudio,
  tsDeskApi: environment.tsDesk.tsDeskApi,
};

export const TSDESK_CONFIG = new InjectionToken<TsDeskConfig>('tsDeskConfig');
